<template>
  <a-modal :title="title" :width="640" :visible="visible" :confirmLoading="confirmLoading" @ok="handleOk" @cancel="handleCancel">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item label="打印机名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['name', { rules: [{ required: true, message: '请输入名称' }] }]" placeholder="如：热菜档口机" />
        </a-form-item>
        <a-form-item label="接入通道" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-radio-group v-decorator="['connectType', { initialValue: 'gateway' }]" @change="e => (connectTypeVal = e.target.value)">
            <a-radio value="gateway">门店网关</a-radio>
            <a-radio value="cloud">云盒</a-radio>
            <a-radio value="direct">直连（预留）</a-radio>
          </a-radio-group>
        </a-form-item>
        <template v-if="connectType === 'gateway'">
          <a-form-item label="所属网关" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-select v-decorator="['gatewaySn']" placeholder="选择门店网关" allow-clear show-search option-filter-prop="children">
              <a-select-option v-for="g in gateways" :key="g.sn" :value="g.sn">{{ g.name }}（{{ g.sn ? g.sn : '未配对' }}）</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="网关下目标" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-radio-group v-decorator="['targetType', { initialValue: 'tcp' }]" @change="e => (targetTypeVal = e.target.value)">
              <a-radio value="tcp">网口打印机（IP）</a-radio>
              <a-radio value="local">网关电脑本机打印机</a-radio>
            </a-radio-group>
          </a-form-item>
          <template v-if="targetType === 'tcp'">
            <a-form-item label="打印机 IP" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['ip']" placeholder="如 192.168.31.108" />
            </a-form-item>
            <a-form-item label="端口" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['port', { initialValue: 9100 }]" :min="1" :max="65535" style="width:120px" />
            </a-form-item>
          </template>
          <a-form-item v-if="targetType === 'local'" label="本机打印机名" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input v-decorator="['localPrinterName']" placeholder="网关电脑上安装的打印机名称（与控制台一致）" />
          </a-form-item>
        </template>
        <template v-if="connectType === 'cloud'">
          <a-form-item label="云盒厂商" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-select v-decorator="['cloudVendor', { initialValue: 'feie' }]">
              <a-select-option value="feie">飞鹅云</a-select-option>
              <a-select-option value="yilianyun">易联云</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="厂商参数" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-textarea v-decorator="['vendorConfig']" :rows="3" placeholder='飞鹅：{"user":"","ukey":"","sn":""}；易联云：{"appId":"","appSecret":"","printerSn":""}' />
          </a-form-item>
        </template>
        <a-form-item label="纸张宽度" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-radio-group v-decorator="['paperType', { initialValue: '80' }]">
            <a-radio value="80">80mm</a-radio>
            <a-radio value="58">58mm</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="打印份数" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number v-decorator="['copies', { initialValue: 1 }]" :min="1" :max="9" style="width:120px" />
        </a-form-item>
        <a-form-item label="打印后走纸" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number v-decorator="['feedLines', { initialValue: 0 }]" :min="0" :max="20" style="width:120px" />
          <span style="margin-left:8px;color:#999">额外走纸行数（0=模板默认）</span>
        </a-form-item>
        <a-form-item label="适用业务" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-checkbox-group v-decorator="['businessTypes', { initialValue: ['dine_in'] }]">
            <a-checkbox value="dine_in">堂食</a-checkbox>
            <a-checkbox value="takeout">外卖</a-checkbox>
            <a-checkbox value="fast_food">快餐</a-checkbox>
          </a-checkbox-group>
        </a-form-item>
        <a-form-item label="联次角色" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-checkbox-group v-decorator="['roles', { initialValue: [] }]" @change="onRolesChange">
            <a-checkbox value="merchant">商家联</a-checkbox>
            <a-checkbox value="customer">顾客联</a-checkbox>
            <a-checkbox value="expo">传菜联</a-checkbox>
            <a-checkbox value="area">区域联</a-checkbox>
          </a-checkbox-group>
          <div style="color:#999;line-height:1.6">商家/顾客联打结算单；传菜联打传菜单（整单/加菜增量）；区域联打区域划菜单（需选择区域或勾选桌台）。各联份数用「联次份数」如 merchant:2,expo:1</div>
        </a-form-item>
        <a-form-item label="联次份数" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['roleCopies']" placeholder="如 merchant:2,customer:1（默认各 1 份）" />
        </a-form-item>
        <a-form-item label="事件单" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-checkbox-group v-decorator="['eventTypes', { initialValue: [] }]">
            <a-checkbox value="add">加菜单</a-checkbox>
            <a-checkbox value="return">退菜单</a-checkbox>
            <a-checkbox value="change_table">换桌单</a-checkbox>
            <a-checkbox value="void">作废单</a-checkbox>
          </a-checkbox-group>
        </a-form-item>
        <a-form-item label="所属区域" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select v-decorator="['areaId']" placeholder="区域服务员联按区域出单（可选）" allow-clear @change="onAreaChange">
            <a-select-option v-for="a in areas" :key="a.id" :value="a.id">{{ a.name }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item v-if="hasAreaRole" label="指定桌台" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <template v-if="areaIdVal">
            <a-checkbox-group v-if="tables.length" :value="checkedTableIds" @change="onTableCheck">
              <a-checkbox v-for="t in tables" :key="t.id" :value="t.id" style="margin:0 12px 6px 0">{{ t.name }}</a-checkbox>
            </a-checkbox-group>
            <div v-else style="color:#999">该区域暂无桌台</div>
            <div style="color:#999;line-height:1.6">未勾选桌台=整区出票；勾选后区域联仅对勾选桌台的订单出票（同区域多台打印机可各管部分桌台）</div>
          </template>
          <div v-else style="color:#999">请先选择所属区域，再勾选该区域的桌台；不勾选则整区出票</div>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>
<script>
import { printerCreate, printerUpdate, areaList, tableList } from '@/api/plugin/dining'

// 下划线行 → 表单模型（后端 queryForList 返回下划线字段）
function toForm(r) {
  return {
    name: r.name,
    connectType: r.connect_type || 'gateway',
    gatewaySn: r.gateway_sn || undefined,
    targetType: r.target_type || 'tcp',
    ip: r.ip,
    port: r.port || 9100,
    localPrinterName: r.local_printer_name,
    cloudVendor: r.cloud_vendor || 'feie',
    vendorConfig: r.vendor_config,
    paperType: r.paper_type || '80',
    feedLines: r.feed_lines || 0,
    copies: r.copies || 1,
    businessTypes: (r.business_types || 'dine_in').split(',').filter(Boolean),
    roles: (r.roles || '').split(',').filter(Boolean),
    roleCopies: r.role_copies,
    areaId: r.area_id || undefined,
    eventTypes: (r.event_types || '').split(',').filter(Boolean)
  }
}

// 下划线行 → 桌台勾选模型（table_ids 逗号分隔 → 数字数组）
function toCheckedTables(r) {
  return (r.table_ids || '').split(',').filter(Boolean).map(Number)
}

export default {
  name: 'DiningPrinterModal',
  props: ['storeId', 'gateways', 'stations'],
  data() {
    return {
      title: '',
      visible: false,
      confirmLoading: false,
      editId: null,
      areas: [],
      connectTypeVal: 'gateway',
      targetTypeVal: 'tcp',
      hasAreaRole: false,   // 勾选了区域联（控制桌台区块显隐）
      areaIdVal: undefined, // 当前选中区域（镜像 form areaId，供桌台加载）
      tables: [],           // 选中区域的桌台列表
      checkedTableIds: [],  // 已勾选桌台 id（区域联精确匹配，空=整区）
      labelCol: { span: 5 },
      wrapperCol: { span: 17, offset: 1 },
      form: this.$form.createForm(this)
    }
  },
  computed: {
    connectType() { return this.connectTypeVal },
    targetType() { return this.targetTypeVal }
  },
  methods: {
    loadAreas() {
      if (!this.storeId) return
      areaList({ storeId: this.storeId }).then(res => {
        if (res.code === 200) {
          this.areas = res.data || []
        }
      })
    },
    // 加载指定区域桌台（复用桌台管理 tableList 接口）
    loadTables(areaId) {
      if (!areaId || !this.storeId) { this.tables = []; return }
      tableList({ storeId: this.storeId, areaId: areaId }).then(res => {
        if (res.code === 200) {
          this.tables = res.data || []
        }
      })
    },
    onRolesChange(checkedValues) {
      this.hasAreaRole = (checkedValues || []).indexOf('area') > -1
    },
    onAreaChange(v) {
      this.areaIdVal = v
      this.checkedTableIds = [] // 换区域后原勾选失效
      this.loadTables(v)
    },
    onTableCheck(checkedValues) {
      this.checkedTableIds = checkedValues || []
    },
    add() {
      this.editId = null
      this.title = '新增打印机'
      this.loadAreas()
      this.connectTypeVal = 'gateway'
      this.targetTypeVal = 'tcp'
      this.resetAreaState()
      this.visible = true
      this.$nextTick(() => this.form.resetFields())
    },
    edit(record) {
      this.editId = record.id
      this.title = '编辑打印机'
      this.loadAreas()
      this.connectTypeVal = record.connect_type || 'gateway'
      this.targetTypeVal = record.target_type || 'tcp'
      this.hasAreaRole = (record.roles || '').split(',').indexOf('area') > -1
      this.areaIdVal = record.area_id || undefined
      this.checkedTableIds = toCheckedTables(record)
      this.loadTables(this.areaIdVal)
      this.visible = true
      this.$nextTick(() => this.form.setFieldsValue(toForm(record)))
    },
    resetAreaState() {
      this.hasAreaRole = false
      this.areaIdVal = undefined
      this.tables = []
      this.checkedTableIds = []
    },
    handleOk() {
      this.form.validateFields((err, values) => {
        if (err) return
        // 区域联路由出单（QY）：需"已选区域"或"已勾桌台"其一；未勾桌台=整区出票
        if ((values.roles || []).indexOf('area') > -1 && !values.areaId && !this.checkedTableIds.length) {
          this.$message.warning('勾选「区域联」时需选择所属区域或勾选桌台（其一即可）')
          return
        }
        const data = {
          storeId: this.storeId,
          name: values.name,
          connectType: values.connectType,
          gatewaySn: values.gatewaySn || '',
          targetType: values.targetType,
          ip: values.ip || '',
          port: values.port,
          localPrinterName: values.localPrinterName || '',
          cloudVendor: values.cloudVendor || '',
          vendorConfig: values.vendorConfig || '',
          paperType: values.paperType,
          feedLines: values.feedLines || 0,
          copies: values.copies || 1,
          businessTypes: (values.businessTypes || []).join(','),
          roles: (values.roles || []).join(','),
          roleCopies: values.roleCopies || '',
          areaId: values.areaId || null,
          tableIds: this.checkedTableIds.join(','),
          eventTypes: (values.eventTypes || []).join(',')
        }
        this.confirmLoading = true
        const req = this.editId ? printerUpdate(this.editId, data) : printerCreate(data)
        req.then(res => {
          this.confirmLoading = false
          if (res.code === 200) {
            this.$message.success(res.message || '保存成功')
            this.visible = false
            this.$emit('ok')
          } else {
            this.$message.warning(res.message)
          }
        }).catch(() => { this.confirmLoading = false })
      })
    },
    handleCancel() { this.visible = false }
  }
}
</script>
